/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { OrganizationSiteMetaData } from '../../models/organization-site-meta-data';

export interface PutOrganizationSiteMetaData$Params {
  organizationKey: KeyType;
  organizationSiteKey: KeyType;
      body: OrganizationSiteMetaData
}

export function putOrganizationSiteMetaData(http: HttpClient, rootUrl: string, params: PutOrganizationSiteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putOrganizationSiteMetaData.PATH, 'put');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putOrganizationSiteMetaData.PATH = '/organizations/{organizationKey}/organization-sites/{organizationSiteKey}/metadata';
